
import Typography from '@/ui-kit/components/typography';
import Gutter from '@/ui-kit/components/gutter';
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { track } from '@/utils/analytics';
import routes from '@/constants/routes';
import { SoldDataEvent } from '@/constants/AnalyticEvents';

export default {
  name: 'SoldDataContactUs',
  components: {
    Typography,
    Gutter,
    Button,
  },
  data() {
    return {
      routes,
      TypographyType,
      TypographyProperty,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
      StyleFontWeightType,
      GutterProperty,
      ButtonProperty,
      ButtonPropsEventType,
    };
  },
  methods: {
    trackContactBodeTeamButtonClick() {
      track(SoldDataEvent.ContactBodeClick);
    },
  },
};
